import { Injectable } from '@angular/core';
import { Subject, Observable, merge } from 'rxjs';
import { map, scan, startWith } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private loadingStart$ = new Subject<void>();
  private loadingEnd$ = new Subject<void>();

  loading$: Observable<boolean> = merge(
    this.loadingStart$.pipe(map(() => 1)),
    this.loadingEnd$.pipe(map(() => -1))
  ).pipe(
    scan((count, change) => Math.max(0, count + change), 0), // リクエスト数を加算/減算
    map((count) => count > 0), // 非ゼロならローディング中
    startWith(false) // 初期値
  );

  show() {
    this.loadingStart$.next();
  }

  hide() {
    this.loadingEnd$.next();
  }
}
